import { environment } from '../../../environments/environment';

export const apiUrl = environment.clientConfig.baseUrl;
export const baseFeaturesUrl = 'iot/v2/features/installations';

// Temporary and needs to be deleted after backend's release
// VIG-18502
export const climateSolutionsDomain = 'https://api.viessmann-climatesolutions.com/';
